var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-page"},[(_vm.embedUrl)?_c('iframe',{staticClass:"embed-page-iframe",attrs:{"src":_vm.embedUrl,"width":"100%","frameborder":"0","allow":"camera *;microphone *; display-capture","allowfullscreen":"true","border":"0"}}):_c('EmbedPageError')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }